//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react"
import { LoadingContext } from "../../context/LoadingContext"
import { Main } from "./components";



//--------------- EXPORTAÇÃO DO COMPONENTE LOADING ---------------//
export default function Loading() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de loading está ou não aparecendo



    // //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
    // useEffect(() => {

    //     let timerLoading = setTimeout(() => { setIsLoading(true) }, 500) // Variável local responsável por tornar o "loading" como "true" apenas após 500ms

    // }, []);



    //--------------- RETORNO DO COMPONENTE LOADING ---------------//
    return (
        <>
            {
                !isLoading
                    ? null
                    : <Main />
            }
        </>
    )

}